import {ILogDeviceData} from '../interfaces/log-device-data.interface';
import Device from '../../../utils/device';

export class LogDeviceDataBuilder {
    constructor(private readonly _reportClientHints: boolean) {

    }


    build(): ILogDeviceData {
        let result: ILogDeviceData ={
            userAgent: Device.getUserAgent(),
            screenResolution: Device.getScreenWidth() + 'x' +  Device.getScreenHeight(),
            isHybridEmbedded: Device.isHybridEmbedded(),
        };

        if(this._reportClientHints && Device.clientHints){
            result.clientHints = Device.clientHints;
        }

        let deviceSystemData = Device.getDeviceSystemData();
        if(deviceSystemData) {
            result.osName = deviceSystemData.operationSystem;
        }

        let networkData = Device.getNetworkData();
        if(networkData)
        {
            result.networkData = networkData;
        }

        return result;
    }

}
